import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import AnnualTradesReportTable from "./AnnualTradesReportTable";
import { usePageStyles } from "../../../pageStyles";
import { PageComponent } from "../../../../core/navigation/types";
import { PageTitle } from "../../../components/common/PageTitle";
import { AnnualTradesReportFilter } from "./AnnualTradesReportFilter";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";

const AnnualTradesReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="secCommAnnualyTradeReportTitle" />}
              action={<AnnualTradesReportActions />}
            />
            <Divider />
            <CardContent>
              <AnnualTradesReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const AnnualTradesReportActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <AnnualTradesReportFilter />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default AnnualTradesReport;
